function getFetchHeaders(payload={}, method){
	const headers = {
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		},
		credentials: 'include'
	};

	if(method === 'GET' || method === 'HEAD'){
		return headers;
	}

	return {
		...headers,
		...{
			method,
			body: JSON.stringify(payload)
		}
	};
}

function throwError(err, message='') {
	console.error(err);
	if(message){
		console.error(message);
	};
}

async function requestApi(endpoint='/', payload={}, method='GET') {
	try {
		const headers = getFetchHeaders(payload, method);
		const response = await fetch(endpoint, headers);
		const json = response.json();
		return json;
	} catch (err) {
		throwError(err);
	}
}

export { requestApi, throwError };



// WEBPACK FOOTER //
// ./mobile-core/src/services/api.js